import { useRouter, type ErrorComponentProps } from '@tanstack/react-router';
import { ErrorPanel } from '../ui/error-boundary.tsx';
import { Skeleton } from '../ui/skeleton.tsx';

const SHELL_SKELETON_LINES = 4;

/** Shown while /me loads before the first authed page. */
export function ShellLoading(): React.JSX.Element {
  return (
    <div className="shell">
      <Skeleton lines={SHELL_SKELETON_LINES} label="Loading the portal…" />
    </div>
  );
}

/** /me failed for a reason other than "not signed in": API down, network, 5xx. */
export function ShellLoadError(props: ErrorComponentProps): React.JSX.Element {
  const router = useRouter();
  return (
    <div className="shell">
      <ErrorPanel
        title="The portal could not load"
        error={props.error}
        onRetry={() => {
          props.reset();
          void router.invalidate();
        }}
      />
    </div>
  );
}
